module.exports = __webpack_public_path__ + "images/browser-logo-chrome-60869e1d83cfe6020c48d65297c82fa1.png";